// extracted by mini-css-extract-plugin
module.exports = {"stack":"PharmaciesLeading_stack__5hdH3","circle":"PharmaciesLeading_circle__cFgbX","image":"PharmaciesLeading_image__kTU84"};